<div>
  <div>
    An excess fee applies if you make a claim. The amount is based on the price
    of your mobile phone.
  </div>

  <div class="feeContainer">
    <div>
      <strong>&pound;{{ fee }} excess fee</strong>
    </div>
    <div>
      &pound;{{ (hasLt ? monthlyFee + ltPrice : monthlyFee) | number: '1.2-2' }}
      per month
    </div>
  </div>
</div>
